<template>
  <div class="row">
    <div class="col-12">
      <PageHeader
        :page="page"
        :has-add="true"
        :has-return="true"
        @onAdd="checkIfIsPrivateStudent()"
        @onReturn="() => $router.back()"
      />
      <div class="row">
        <div class="col-12">
          <SectionTitle content="Traslados" :has-line="true" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div
            class="row mx-0 d-flex justify-content-between align-items-center header thead-property"
          >
            <div class="col-2 py-0">
              <span>Tipo de Escuela</span>
            </div>
            <div class="col-2 py-0">
              <span>Fecha Inicio</span>
            </div>
            <div class="col-2 py-0">
              <span>Región</span>
            </div>
            <div class="col-2 py-0">
              <span class="pl-1">Distrito</span>
            </div>
            <div class="col-2 py-0">
              <span class="pl-1">Escuela</span>
            </div>
            <div class="col-2 py-0">
              <!-- Espacio en blanco para botón de acciones -->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div v-for="item in rows" :key="item.label" class="col-12">
          <div class="subheader tsubhead-property d-flex align-items-center">
            <strong class="pl-2">
              {{ item.label }}
            </strong>
          </div>

          <Accordion id="accordionTrasfer">
            <AccordionItem
              v-for="itemC in item.children"
              :id="'accordionTrasfer' + itemC.id"
              :key="itemC.id"
              :title="itemC.detail.type"
              :expanded="false"
              :title-bold="false"
              :title-style="'col-md-2'"
              :content-style="'col-md-9 pl-4'"
            >
              <template slot="header-content">
                <div class="row">
                  <div
                    class="col-md-3 col-sm col-12 py-0 d-flex align-items-center"
                  >
                    <span class=" font-weight-normal">
                      {{ itemC.startDate }}
                    </span>
                  </div>
                  <div
                    style="position:relative;right: 18px;"
                    class="col-md-2 col-sm col-12 p-0 py-0 d-flex align-items-center"
                  >
                    <span class=" font-weight-normal">
                      {{ itemC.region }}
                    </span>
                  </div>
                  <div class="col-md-2 py-0 mr-5 d-flex align-items-center">
                    <span class=" pl-md-3 pl-sm-1 font-weight-normal">
                      {{ itemC.district }}
                    </span>
                  </div>
                  <div class="col-md-3 py-0 d-flex align-items-center">
                    <span class="pl-sm-1 font-weight-normal">
                      {{ itemC.school }}
                    </span>
                  </div>
                  <div v-if="canDelete" class="col dropdown mt-2">
                    <button
                      id="dropdownMenuButton"
                      class="btn btn-dropdown-actions dropdown-toggle  pt-1"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Acciones
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <div
                        class="dropdown-item"
                        @click.prevent="remove(itemC.locationTranferId)"
                      >
                        <i class="fas fa-times-circle text-red pr-1" />
                        <span>Eliminar</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template slot="content">
                <div class="px-4">
                  <div class="row m-0">
                    <div class="col-12 border-top" />
                  </div>
                  <div class="row py-2">
                    <div class="col-md-3 py-0 px-3">
                      <strong>Servicio:</strong>
                      <p class="font-weight-normal">
                        {{ itemC.service }}
                      </p>
                    </div>
                    <div class="col-md-2 py-0 pl-3">
                      <strong class="pl-1">Residencia:</strong>
                      <p class="pl-1 font-weight-normal">
                        {{ itemC.detail.residence | capitalize }}
                      </p>
                    </div>
                    <div class="col-md-2 py-0 pl-3">
                      <strong class="pl-1">Creado:</strong>
                      <p class="pl-1 font-weight-normal">
                        {{ itemC.detail.fullName }}
                        <br />
                        {{ itemC.detail.date }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-9">
                      <strong>Comentario:</strong>
                      <p class="text-justify font-weight-normal">
                        {{ itemC.detail.comment }}
                      </p>
                    </div>
                  </div>
                </div>
              </template>
            </AccordionItem>
          </Accordion>
        </div>
      </div>

      <div v-if="rows.length === 0" class="col-12 p-0">
        <div class="subheader-footer d-flex align-items-center">
          <div class="row w-100">
            <div class="col-12 pt-0 ">
              <em class="fal fa-folder-open icon" />
              <span class="tsubhead-footer">No hay Traslados registrados.</span>
            </div>
          </div>
        </div>
      </div>

      <customPager
        ref="historyPager"
        :per-page="tableConfig.serverParams.perPage"
        :total="tableConfig.totalRecords"
        :page-changed="onPageChange"
        :per-page-changed="onPerPageChange"
      />
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
import moment from 'moment';
import PageHeader from '@/components/common/page/PageHeader';
import { SectionTitle } from '@/components/pei/shared';
import resourcesService from '@/services/resources.js';
import studentApi from '@/services/student.js';
import mixAlert from '@/mixin/alert.mixin';
import { Accordion, AccordionItem } from '@/components/pei/shared/accordion';

export default {
  name: 'TransferHistory',
  mixins: [mixAlert],
  components: {
    SectionTitle,
    Accordion,
    AccordionItem,
    PageHeader,
  },
  data() {
    return {
      loadedStudent: false,
      page: {
        icon: 'fas fa-user-circle',
        title: 'Estudiante: Historial de Traslado',
        routes: ['Inicio', 'Estudiante', 'Traslado'],
      },
      resources: [],
      rows: [],
      tableConfig: {
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: '',
            type: '',
          },
          page: 1,
          perPage: 10,
        },
      },
      student: Object,
    };
  },
  computed: {
    mipeStudentInfo() {
      return this.$store.getters['$_student/getMipeStudent'];
    },
    isStudentPublic() {
      const mipeStudent = this.mipeStudentInfo.mipeStudent ?? {};
      return mipeStudent.studentIsPublic;
    },
    canDelete() {
      return this.$store.getters.HasPermission('student.transfer.delete');
    },
  },
  methods: {
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    getHistory() {
      this.$ApiGet(
        '/api/student/transferhistory?studentSieId=' +
          store.getters['$_student/StudentSie']
      )
        .then((res) => {
          this.rows = res.data.data ? this.formatData(res.data.data) : [];
          this.tableConfig.totalPages = res.data.pageCount;
          this.tableConfig.totalRecords = res.data.totalItemCount;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    formatData(data) {
      const rows = [];
      const group = data.reduce(function(r, a) {
        const name = 'Año Académico: ' + a.academicYear;
        r[name] = r[name] || [];
        r[name].push(a);
        return r;
      }, Object.create(null));

      Object.keys(group).forEach((key) => {
        const row = {
          label: key,
          children: [],
        };
        group[key].forEach((element, indexChildren) => {
          const children = {
            locationTranferId: element.studentLocationTranferId,
            id: new Date(element.date).getTime() + '' + indexChildren,
            region: element.region,
            startDate: this.formatDate(element.startDate),
            service: element.service,
            district: element.district,
            school: element.school,
            detail: {
              type: element.type,
              residence: element.residence,
              date: this.formatDate(element.date),
              fullName: element.fullName,
              comment: element.comment,
            },
          };

          row.children.push(children);
        });
        rows.push(row);
      });
      return rows;
    },
    //ECG:Table methods
    updateParams(newProps) {
      this.tableConfig.serverParams = Object.assign(
        {},
        this.tableConfig.serverParams,
        newProps
      );
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getHistory();
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.getHistory();
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '21010',
        '22039',
      ]);
    },
    checkIfIsPrivateStudent() {
      //Los traslados solo aplican a estudiantes privados
      if (this.isStudentPublic) {
        this.ShowToast('Advertencia', this.resources['21010'], 'warning');
      } else {
        let studentStatus = this.$store.state.$_student.selectedStudent.status;
        if (
          studentStatus == 'Inactivo' ||
          studentStatus == 'Egreso' ||
          studentStatus == 'No Elegible'
        ) {
          this.ShowToast('Advertencia', this.resources['22039'], 'warning');
        } else {
          this.goToAddTransfer();
        }
      }
    },
    goToAddTransfer() {
      this.$router.push({ path: '/student/transferhistory/form' });
    },
    async remove(locationTranferId) {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar el translado?',
        'Aceptar',
        'Cancelar'
      );
      if (answer) {
        await studentApi.removeTransfer(locationTranferId);
        this.getHistory();
      }
    },
  },
  mounted() {
    this.getHistory();
  },
  created() {
    this.loadResources();
  },
};
</script>
<style scoped>
.accordion {
  background-color: #fafbfa;
}

.accordion >>> .card-header {
  border-bottom-color: #fafbfa;
}
.accordion >>> .accordion-header[aria-expanded='false'] {
  background-color: #fafbfa;
}

.accordion >>> .accordion-header[aria-expanded='true'] {
  background-color: #fafbfa;
}

.header {
  height: 54px;
  padding-left: 20px;
  background: #3f5b60 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.subheader {
  height: 54px;
  padding-left: 20px;
  background: #e7ebe9 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  font-weight: bold;
}

.thead-property {
  color: #ffffff;
}

.subheader-footer {
  height: 150px;
  padding-left: 20px;
  background: #fafbfa 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
}

.subheader-footer .icon {
  font-size: 35px;
  height: 60px;
  width: 60px;
  border: solid 3px;
  border-radius: 127px;
  padding-top: 10px;
  padding-left: 3px;
  color: #e2e2e2;
}

.tsubhead-footer {
  color: #727272;
  font-weight: bold;
  font-size: 22px;
  padding-left: 15px;
  padding-bottom: 13px;
  vertical-align: super;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.text-fix {
  font-weight: 400;
}
</style>
